<template>
    <ToolButton :Editor="Editor" KnownIcon="TableInsertRowBottom" @ToolClick="Editor.chain().focus().addRowAfter().run()">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>